<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style  lang="less">
@import 'assets/iconfont/iconfont.css';
.size{
  width: 100%;
  height: 100%;
}
html,body{
  .size;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
#app {
  .size;
}
.el-table .el-table__header th{
  background-color: #EFF3F9;
}
.el-menu-item.is-active{
  background-color: #EFF3F9;
}
.el-card__header {
  border-bottom: none !important;
  padding: 18px 20px 0 20px !important;
}
.el-card {
  border-radius: 10px !important;
}
.el-checkbox__input.is-checked + .el-checkbox__label{
  color: #00BEFF !important;
}
.el-radio__input.is-checked + .el-radio__label{
  color: #00BEFF !important;
}
.el-button--text{
  color: #00BEFF !important;
}
.el-progress-bar__inner{
  background-color: #00BEFF !important;
}
.el-radio__input.is-checked .el-radio__inner{
  background-color: #00BEFF !important;
  border-color: #00BEFF !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #00BEFF !important;
  border-color: #00BEFF !important;
}
.el-button--primary{
  background-color: #00BEFF !important;
  border-color: #00BEFF !important;
}
.el-table__footer-wrapper tbody td, .el-table__header-wrapper tbody td{
  color: #24bbee !important;
  background-color: #ffffff !important;
  border: none !important;
}
.el-radio-button__orig-radio:checked + .el-radio-button__inner{
  background-color: #00BEFF !important;
  border-color: #00BEFF !important;
}
/*.el-input-number {
  span {
    background-color: #409EFF;
    color: #ffffff;
    font-size: 14px;
    &:hover{
      color: #ffffff;
    }
  }
  .el-input__inner {
    border: 1px solid #409EFF;
  }
}*/

.el-pagination .el-select .el-input .el-input__inner{
  border-radius: 4px;
}
.el-pagination .btn-next{
  border-radius: 0 4px 4px 0;
}
.el-pagination .btn-prev{
  border-radius: 4px 0 0 4px;
}
.el-loading-mask{
  background-color: rgba(255,255,255,.3) !important;
}
.el-loading-spinner{
  display: none;
}
.el-table::before{
  height: 0px !important;
}
</style>
